import { ChangeEvent, Dispatch, FC, SetStateAction, useState } from "react";
import "./HelpCenterHomeTopbar.css";
import searchIcon from "@gigauser/common/src/assets/svgs/searchIcon";
import Icon from "@gigauser/common/src/ui/Icon/Icon";
import { GuidePreview } from "@gigauser/common/src/core/types/guide";
import useRunDebouncedSearch from "../../../../hooks/useRunDebouncedSearch";
import LoadingRing from "@gigauser/common/src/assets/gifs/LoadingRing/LoadingRing";
import { helpSaver } from "@gigauser/common/src/network/helpcenterSaver";
import orgSetupData, {
	getTopbarTitle,
} from "@gigauser/common/src/setup/orgSetupData";

type HelpCenterHomeTopbarProps = {
	loadingSearch: boolean;
	setLoadingSearch: Dispatch<SetStateAction<boolean>>;
	setSearchResults: Dispatch<SetStateAction<GuidePreview[]>>;
};

const HelpCenterHomeTopbar: FC<HelpCenterHomeTopbarProps> = (props) => {
	const [searchInput, setSearchInput] = useState("");

	const runDebouncedSearch = useRunDebouncedSearch();

	const setLoading = (b: boolean) => {
		props.setLoadingSearch(b);
	};

	const setResults = (g: GuidePreview[]) => {
		props.setSearchResults(g);
	};

	const onChangeSearchInput = (e: ChangeEvent<HTMLInputElement>) => {
		setSearchInput(e.target.value);

		runDebouncedSearch({
			searchString: e.target.value,
			setLoading,
			setResults,
		});
	};

	let searchTitle = "Search for help ...";
	if (helpSaver.organization?.id && orgSetupData[helpSaver.organization.id]) {
		searchTitle =
			orgSetupData[helpSaver.organization?.id].searchTitle ||
			"Search for help";
	}

	return (
		<div className="HelpCenterHomeTopbar">
			<div className="HelpCenterHomeTopbar-top">
				<div className="HelpCenterHomeTopbar-top-left">
					<img
						className="brand-logo"
						src={`https://clueso-public-assets.s3.ap-south-1.amazonaws.com/${helpSaver.organization?.id}.svg`}
					/>
					<div>{getTopbarTitle(helpSaver.organization)}</div>
				</div>

				<div className="HelpCenterHomeTopbar-top-right">
					<div>Log in to Scrut</div>
					<div>Contact Us</div>
				</div>
			</div>

			<div className="HelpCenterHomeTopbar-title">
				Hi, how can we help today?
			</div>

			<div className="HelpCenterHomeTopbar-search">
				{props.loadingSearch ? (
					<div className="searchIcon">
						<LoadingRing />
					</div>
				) : (
					<Icon className="searchIcon">{searchIcon("white")}</Icon>
				)}

				<input
					onChange={onChangeSearchInput}
					value={searchInput}
					className="HelpCenterHomeTopbar-search-input"
					placeholder={searchTitle || "Search for help ..."}
				/>
			</div>
		</div>
	);
};
export default HelpCenterHomeTopbar;
